import AuthService from "../../AuthService";
const serviceArea = {
  getServiceArea(page) {
    return AuthService.get("/service/service_area?page=" + page);
  },
  showServiceArea(id) {
    return AuthService.get("/service/service_area/" + id);
  },
  createServiceArea(data) {
    return AuthService.post("/service/service_area", data);
  },
  updateServiceArea(id, data) {
    return AuthService.put("/service/service_area/" + id, data);
  },
  deleteServiceArea(id) {
    return AuthService.delete("/service/service_area/" + id);
  }
};
export default serviceArea;
